import { apiCallStrapi } from '@/utils/fetch';
import { APIPath, paths } from './constants';
import { PageResponse } from '@/cms';
import { Logger } from '@/lib/Logging';
import { RedirectEntriesProps, getRedirectsFromStrapi } from '@/lib/redirects';

const logger = new Logger('src/cms/getLinks.ts');

export async function getLinks({ apiPath }: { apiPath?: APIPath } = {}) {
  const currentPath = paths.find((path) => path.apiPath === apiPath);
  const selectedPaths = currentPath ? [currentPath] : paths;

  const requestsPromise = selectedPaths.map(async ({ apiPath, urlPrefix }) => {
    const query = {
      pagination: {
        page: 1,
        pageSize: 1000,
      },
    };

    const response = await apiCallStrapi<PageResponse>({
      path: apiPath,
      query,
      method: 'GET',
    });

    const data = response?.data;

    let redirectsData: RedirectEntriesProps[] = [];
    try {
      redirectsData = await getRedirectsFromStrapi();
    } catch (error) {
      logger.error({
        message: 'Error fetching redirects from Strapi in getLinks:',
        context: error,
      });
    }

    const filteredData = data?.filter((page) => {
      const slug = page.attributes.slug;
      const apiPathMap = {
        '/pages': null,
        '/blog-topics': '/blog/topics',
        '/blogs': '/blog',
        '/footers': null,
        '/headers': null,
      };
      const fullSlug = `${apiPathMap[apiPath] || ''}/${slug}`;

      const hasRedirect = redirectsData.some(
        (redirect) => redirect.from === fullSlug
      );

      return !hasRedirect;
    });

    filteredData?.map((page) => {
      const slug = page.attributes.slug;
      page.attributes.slug =
        slug === '/' ? '/' : `${urlPrefix ? urlPrefix + '/' : ''}${slug}`;
      page.attributes.originalSlug = slug;
      page.attributes.prefixSlug = urlPrefix;
      page.attributes.apiPath = apiPath;
    });

    return filteredData ?? null;
  });

  const requests = await Promise.allSettled(requestsPromise);
  const links = requests?.map((request) => {
    if (request.status === 'rejected') {
      logger.error(request.reason);
      return [];
    }

    return request.value;
  });

  return links.flat() ?? null;
}
